import * as messagingTypes from './messagingTypes';
import { MESSAGEBOX_TYPES, MESSAGEDETAIL_TYPES, TIMER_START, TIMER_STOP, TIMER_TYPES, MSG_MONITOR_INTERVAL } from 'src/constants/constants';
import {
  assignCaseToMessageAPI,
  delMessages,
  downloadAttachmentService,
  fetchCasesMessages,
  fetchCounts,
  fetchFilters,
  fetchMessageDetails,
  fetchMessages,
  postMessage,
  searchParties,
  upLoadAttachmentService,
  delDraftMessages,
} from 'src/services/messages.service';
import { getLastMailDate, getFirstMailDate, getFiltersByMailBox, getFirstMessage, getLoginInfo } from './messagingReselect';
import { getCaseId } from 'src/ui/features/Cases/state/casesReselect';
import { push } from 'redux-first-history';
import { PRIORITY, MESSAGING_COMPOSE_URL } from '../../../../constants/constants';
import { saveAPIFile } from 'src/helpers';
import { showNotification } from 'src/utils/utilsActions';
import { getCaseMessagesCountsPending, getMessagesCount } from '../../Cases/state/casesActions';
import axios from 'axios';

const CancelToken = axios.CancelToken;

let requestTokens = [];

export const stopMessagingRequest = () => {
  stopMessagingMonitor();
  requestTokens.forEach(fn => {
    fn();
  });
  return {
    type: messagingTypes.STOP_MESSAGING_REQUESTS,
  };
};

export const getAllMailAndCounts = opts => {
  return (dispatch, getState, setLock, onStart, onComplete) => {
    dispatch(resetMessageLoader());
    onStart();
    /*
     * We can not rely on counts so the way to examine changes is to ping each endpoint with a fromDate of the last mail and then
     * Fire off requests to each mailbox in parallel then retrieve the counts after promises are resolved
     */

    //FIRST DATES
    // const firstInboxDate = getFirstMailDate(getState(), MESSAGEBOX_TYPES.INBOX);
    // const firstSentDate = getFirstMailDate(getState(), MESSAGEBOX_TYPES.SENT);
    //const firstDraftDate = getFirstMailDate(getState(), MESSAGEBOX_TYPES.DRAFT);

    // const caseId = getCaseId(getState());

    let inboxFilters = getFiltersByMailBox(getState(), MESSAGEBOX_TYPES.INBOX);
    let sentFilters = getFiltersByMailBox(getState(), MESSAGEBOX_TYPES.SENT);
    let draftFilters = getFiltersByMailBox(getState(), MESSAGEBOX_TYPES.DRAFT);
    // const selectedEngagement = getState().dashboard.selectedEngagement;

    //const mailBoxTypes = ['inbox', 'sent', 'drafts'];

    if (opts) {
      const { mailBoxes } = opts;
      if (mailBoxes) {
        delete opts.mailBoxes;
        if (mailBoxes.inbox) {
          inboxFilters = { ...inboxFilters, ...opts };
        }
        if (mailBoxes.sent) {
          sentFilters = { ...sentFilters, ...opts };
        }
        if (mailBoxes.draft) {
          draftFilters = { ...draftFilters, ...opts };
        }
      }
    }
    const inboxParams = {
      // ...(caseId && { caseId }),
      ...inboxFilters,
      pageNumber: 1,
      // ...(inboxFilters.sortDirection === 'desc' && { dateFrom: firstInboxDate }),
      // ...(inboxFilters.sortDirection === 'asc' && { dateTo: firstInboxDate }),
      // engagementId: selectedEngagement && selectedEngagement.engagementId,
    };

    const sentParams = {
      // ...(caseId && { caseId }),
      ...sentFilters,
      pageNumber: 1,
      // ...(sentFilters.sortDirection === 'desc' && { dateFrom: firstSentDate }),
      // ...(sentFilters.sortDirection === 'asc' && { dateTo: firstSentDate }),
      // engagementId: selectedEngagement && selectedEngagement.engagementId,
    };

    const draftsParams = {
      // ...(caseId && { caseId }),
      ...draftFilters,
      pageNumber: 1,
      // dateFrom: '',
      // engagementId: selectedEngagement && selectedEngagement.engagementId,
    };

    function addToTokens(c) {
      requestTokens.push(c);
    }

    requestTokens = [];

    const mailBoxesAndFilters = [
      {
        type: MESSAGEBOX_TYPES.INBOX,
        action: fetchMessages('INBOX_LOADING', MESSAGEBOX_TYPES.INBOX, inboxParams, {
          cancelToken: new CancelToken(function(c) {
            addToTokens(c);
          }),
        }),
      },
      {
        type: MESSAGEBOX_TYPES.SENT,
        action: fetchMessages('SENT_LOADING', MESSAGEBOX_TYPES.SENT, sentParams, {
          cancelToken: new CancelToken(function(c) {
            addToTokens(c);
          }),
        }),
      },
      {
        type: MESSAGEBOX_TYPES.DRAFT,
        action: fetchMessages('DRAFT_LOADING', MESSAGEBOX_TYPES.DRAFT, draftsParams, {
          cancelToken: new CancelToken(function(c) {
            addToTokens(c);
          }),
        }),
      },
      {
        type: 'filters',
        action: fetchFilters({ caseId: inboxParams.caseId }),
      },
    ];

    dispatch(getCounts(inboxParams));

    // For Case Details
    if (inboxParams.caseId) {
      dispatch(getMessagesCount(inboxParams.caseId));
    }

    Promise.all(mailBoxesAndFilters.map(box => box.action)).then(results => {
      try {
        if (results[0].error) {
          const { error } = results[0];
          if (error.code && error.code === '403') {
            dispatch({ type: messagingTypes.CHECK_STATUS });
          }
          throw Error(error.message);
        }
        results.forEach((item, index) => {
          if (item) {
            if (mailBoxesAndFilters[index].type === 'filters') {
              dispatch(getFiltersSuccess(item));
            } else {
              dispatch(getMessagesSuccess(mailBoxesAndFilters[index].type, item, true));
            }
          }
        });

        setLock(false);
        onComplete();
      } catch (error) {
        setLock(false);
      }
    });

    setLock(true);
  };
};

export const getFiltersSuccess = data => ({
  type: messagingTypes.GET_FILTERS,
  data,
});

export const emptyInboxMessages = () => ({
  type: messagingTypes.EMPTY_INBOX_MESSAGES,
});

export const runMessagingMonitor = (opts, resetMesage = false) => {
  return dispatch => {
    if (resetMesage) {
      if (opts) {
        const { mailBoxes } = opts;
        if (mailBoxes) {
          if (mailBoxes.inbox) {
            dispatch(selectMenu(MESSAGEBOX_TYPES.INBOX));
          } else if (mailBoxes.sent) {
            dispatch(selectMenu(MESSAGEBOX_TYPES.SENT));
          } else if (mailBoxes.draft) {
            dispatch(selectMenu(MESSAGEBOX_TYPES.DRAFT));
          }
        }
      }
      dispatch(resetMessageShown());
    }
    dispatch({
      type: TIMER_START,
      payload: {
        name: TIMER_TYPES.MESSAGING,
        action: getAllMailAndCounts(opts),
        timeout: MSG_MONITOR_INTERVAL,
        ...opts,
      },
    });
  };
};

export const stopMessagingMonitor = () => ({
  type: TIMER_STOP,
  payload: {
    name: TIMER_TYPES.MESSAGING,
  },
});

export const selectMessage = id => {
  return async (dispatch, getState) => {
    dispatch({ type: messagingTypes.SELECT_MESSAGE, id });
    dispatch(getMessageDetails(id));
  };
};

export const selectMenu = data => ({
  type: messagingTypes.SELECT_MENU,
  data,
});

export const selectDetailView = data => {
  return (dispatch, getState) => {
    if (getState().messaging.detailType !== data) {
      dispatch(resetComposeId());
    }
    dispatch({
      type: messagingTypes.SELECT_DETAIL_VIEW,
      data,
    });
  };
};

export const getMessagesSuccess = (menu, data, insertFront = false) => {
  if (menu === 'sent') {
    data.messages = data.messages.map(message => {
      message.read = true;
      return message;
    });
  }

  return {
    type: messagingTypes.GET_MESSAGES_SUCCESS,
    menu,
    data,
    insertFront,
  };
};

export const getMessageDetailsSuccess = data => ({
  type: messagingTypes.GET_MESSAGE_DETAILS_SUCCESS,
  data,
});

export const fnRefreshDashboardUnReadCount = () => ({
  type: messagingTypes.RESET_REFRESH_DASHBOARD_UN_READ_COUNT,
});
export const getCountsSuccess = data => ({
  type: messagingTypes.GET_COUNTS_SUCCESS,
  data,
});

export const resetMenu = () => {
  return async dispatch => {
    dispatch({ type: messagingTypes.RESET_MENU });
  };
};

export const getPaginatedMessages = () => {
  return async (dispatch, getState) => {
    const currentState = getState();

    const { userInfo } = getLoginInfo(getState());
    const mailboxType = currentState.messaging.selectedMenu;
    const caseId = getCaseId(getState());
    const selectedEngagement = getState().dashboard.selectedEngagement;

    const lastDate = getLastMailDate(getState(), mailboxType);
    const boxFilters = getFiltersByMailBox(getState(), mailboxType);

    //if (mailboxType === 'draft') return false; //disable bottom update for drafts
    if (IsMessageLimit(currentState, mailboxType)) {
      await fetchMessages(
        mailboxType.toUpperCase() + '_LOADING',
        mailboxType,
        {
          ...(caseId && { caseId }),
          ...boxFilters,
          //dateTo: lastDate,
          ...(boxFilters.sortDirection === 'desc' && { dateTo: lastDate }),
          ...(boxFilters.sortDirection === 'asc' && { dateFrom: lastDate }),
          engagementId: selectedEngagement && selectedEngagement.engagementId,
          pageNumber: currentState.messaging.pageNumber + 1,
        },
        userInfo.personId,
      ).then(res => {
        dispatch(getMessagesSuccess(mailboxType, res));
      });
    }
  };
};

export const IsMessageLimit = (currentState, menuType) => {
  switch (menuType) {
    case 'inbox':
      return currentState.messaging.inbox.messages.length < currentState.messaging.countInbox;
    case 'draft':
      return currentState.messaging.draft.messages.length < currentState.messaging.countDrafts;
    case 'sent':
      return currentState.messaging.sent.messages.length < currentState.messaging.countSent;
    default:
      return false;
  }
};

export const getMessageDetails = messageId => {
  return async (dispatch, getState) => {
    dispatch(getMessageDetailsSuccess((await fetchMessageDetails(messageId)).message));
  };
};

export const getCounts = params => {
  return async dispatch => {
    const counts = await fetchCounts(params);
    dispatch(getCountsSuccess(counts));
  };
};

export const selectShownId = () => {
  return async (dispatch, getState) => {
    const id = getState().messaging.messageShown.id;
    dispatch({ type: messagingTypes.SELECT_MESSAGE, id });
  };
};

export const deepLinkInbox = messageId => {
  return async (dispatch, getState) => {
    const messageDetails = await fetchMessageDetails(messageId);
    if (messageDetails) {
      const message = messageDetails.message;
      dispatch(getMessageDetailsSuccess(message));

      dispatch({ type: messagingTypes.SELECT_MESSAGE, id: messageId });
      dispatch(selectDetailView(MESSAGEDETAIL_TYPES.VIEWMESSAGE));
    }
  };
};

export const selectMenuAndReset = (menu, resetMessage = true, dashboard) => {
  return async (dispatch, getState) => {
    if (resetMessage) {
      dispatch(resetMessageShown());
    }
    // added this here to select menus/folders. May be wrong but could not otherwise until below code is debugged
    dispatch(selectMenu(menu));
    dispatch(runMessagingMonitor());

    dispatch(
      runMessagingMonitor({
        onInitialComplete: async () => {
          let message,
            messageId,
            dashSelectedId = getState().dashboard.selectedMessageId;
          if (dashSelectedId && menu === 'inbox') {
            messageId = dashSelectedId;
          } else if (!dashSelectedId && dashboard) {
            messageId = undefined;
          } else {
            message = getFirstMessage(getState(), menu);
            const selectedIndex = getState().messaging[menu].meta.selectedIndex;
            messageId = selectedIndex ? selectedIndex : message ? message.id : null;
          }
          if (!messageId) {
            dispatch(selectMenu(menu));
          } else {
            let messageDetails = await fetchMessageDetails(messageId);
            if (messageDetails) {
              message = messageDetails.message;
              dispatch({ type: messagingTypes.SELECT_MESSAGE, id: messageId });

              //on ready, select for case msg
              setTimeout(() => {
                dispatch(getMessageDetailsSuccess(message));
              });
            }

            // if a user is leaving compose allow this change to happen
            // need to revisit this
            if (getState().messaging.selectedMenu === MESSAGEBOX_TYPES.DRAFT && menu !== MESSAGEBOX_TYPES.DRAFT) {
              dispatch(selectDetailView(MESSAGEDETAIL_TYPES.VIEWMESSAGE));
            } else if (menu === MESSAGEBOX_TYPES.DRAFT) {
              dispatch(selectDetailView(MESSAGEDETAIL_TYPES.DRAFT));
            }

            dispatch(selectMenu(menu));
            dispatch(selectShownId());
          }
        },
      }),
    );
  };
};

export const searchMessages = menu => {
  return async (dispatch, getState) => {
    dispatch(resetMessageShown());
    dispatch(
      runMessagingMonitor({
        onComplete: async () => {
          let message, messageId;
          message = getFirstMessage(getState(), menu);
          messageId = message ? message.id : null;

          if (!messageId) return;

          message = (await fetchMessageDetails(messageId)).message;
          dispatch({ type: messagingTypes.SELECT_MESSAGE, id: messageId });
          dispatch(getMessageDetailsSuccess(message));
          dispatch(selectShownId());
          dispatch(selectMenu(menu));
        },
      }),
    );
  };
};

export const deleteMessages = (menu, data, callback) => {
  return async (dispatch, getState) => {
    const { error } = await delMessages(data);
    let filters = getFiltersByMailBox(getState(), MESSAGEBOX_TYPES.INBOX);
    const filterParams = { ...filters, pageNumber: 1 };
    if (!error) {
      dispatch(removeMessageFromState(menu, data));
      dispatch(getCounts(filterParams));
      dispatch(selectMenuAndReset(menu));
      if (typeof callback === 'function') {
        callback();
      }
    }
  };
};

export const deleteDraftMessages = (menu, data, callback) => {
  return async (dispatch, getState) => {
    const { error } = await delDraftMessages(data);
    let filters = getFiltersByMailBox(getState(), MESSAGEBOX_TYPES.INBOX);
    const filterParams = { ...filters, pageNumber: 1 };
    if (!error) {
      dispatch(removeMessageFromState(menu, [data]));
      dispatch(getCounts(filterParams));
      dispatch(selectMenuAndReset(menu));
      if (typeof callback === 'function') {
        callback();
      }
    }
  };
};

export const removeMessageFromState = (menu, msgId) => ({
  type: messagingTypes.REMOVE_MESSAGE_FROM_STATE,
  menu,
  msgId,
});

export const showNotificationSuccess = data => ({
  type: messagingTypes.SHOW_NOTIFICATION_SUCCESS,
  data,
});

export const sendMessagePending = () => ({
  type: messagingTypes.SENDMESSAGE_PENDING,
});

export const hideNotificationSuccess = () => ({
  type: messagingTypes.HIDE_NOTIFICATION_SUCCESS,
  data: '',
});

export const assignCaseToMessage = payload => {
  return async (dispatch, getState) => {
    await assignCaseToMessageAPI(payload).then(res => {
      if (!(res && (res.errors || res.error))) {
        dispatch(selectMessage(payload.messageId));
      }
    });
  };
};

export const sendMessage = (message, notifText, simpleSave, callback = () => {}) => {
  return async (dispatch, getState) => {
    dispatch(sendMessagePending());
    message.append('priority', message.get('priority') ? PRIORITY.HIGH.toLowerCase() : PRIORITY.NORMAL.toLowerCase());
    const response = await postMessage(message);
    let filters = getFiltersByMailBox(getState(), MESSAGEBOX_TYPES.INBOX);
    const filterParams = { ...filters, pageNumber: 1 };
    if (response && !response.error) {
      dispatch(getCounts(filterParams));
      dispatch(showNotification(notifText, { variant: 'success' }));
      callback();

      /* For simple save operation escape all of the other ceremony */
      if (typeof simpleSave === 'boolean' && simpleSave) return;

      const draftmessages = getState().messaging.draft.messages;
      // Check if 1st message in draft list is sent, If "Yes" and if there are more than 1 records in the list,
      // set the focus on next message. Else call the readonly view as there are no more draft messages left.
      if (getState().messaging.selectedMenu === MESSAGEBOX_TYPES.DRAFT) {
        dispatch(selectDetailView(MESSAGEDETAIL_TYPES.DRAFT));
        if (!message.isdraft && draftmessages.length > 0)
          if (draftmessages[0].id === message.messageId) {
            draftmessages.length === 1
              ? dispatch(selectDetailView(MESSAGEDETAIL_TYPES.VIEWMESSAGE))
              : dispatch(selectMessage(draftmessages[1].id));
          } else dispatch(selectMessage(draftmessages[0].id));
      } else dispatch(selectDetailView(MESSAGEDETAIL_TYPES.VIEWMESSAGE));

      dispatch(runMessagingMonitor());
      dispatch(resetAttachments());
      dispatch(selectMenuAndReset(getState().messaging.selectedMenu));
      dispatch(getCaseMessagesCountsPending());
    } else {
      callback(response.error.message);
    }
  };
};

export const applyFilters = payload => ({
  type: messagingTypes.APPLY_FILTERS_PENDING,
  payload,
});
export const applyFiltersSuccess = () => ({
  type: messagingTypes.APPLY_FILTERS_SUCCESS,
});
export const applyFiltersFailure = error => ({
  type: messagingTypes.APPLY_FILTERS_FAILURE,
  error,
});

export const clearFilters = () => ({
  type: messagingTypes.CLEAR_FILTERS_PENDING,
});

export const clearFiltersSuccess = () => ({
  type: messagingTypes.CLEAR_FILTERS_SUCCESS,
});

//showModal
export const toggleModal = (status, anchorEl) => ({
  type: messagingTypes.SHOW_FILTER_MODAL,
  status,
  anchorEl,
});

//handleAnchor
export const changeSortOrder = sortDirection => ({
  type: messagingTypes.CHANGE_SORT_ORDER,
  sortDirection,
});

export const switchView = view => ({
  type: messagingTypes.SWITCH_VIEW,
  view,
});

export const loadEngagementsPending = () => ({
  type: messagingTypes.ENGAGEMENT_LOAD_PENDING,
});

export const loadEngagementsSuccess = engagements => ({
  type: messagingTypes.ENGAGEMENT_LOAD_SUCCESS,
  engagements,
});

export const toggleComposeDrawer = () => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({
      type: messagingTypes.TOGGLE_COMPOSE_DRAWER,
      payload: {
        open: !state.messaging.composeDrawerState.open,
      },
    });
  };
};

export const checkStatusPending = () => ({
  type: messagingTypes.CHECK_STATUS,
});

export const setAttachments = (composeId, attachmentId) => ({
  type: messagingTypes.SET_ATTACHMENTS,
  composeId,
  attachmentId,
});

export const setComposeId = data => ({
  type: messagingTypes.SET_COMPOSE_ID,
  data,
});

export const upLoadAttachment = (data, callback) => {
  return async dispatch => {
    const response = await upLoadAttachmentService(data, {
      timeout: 180000,
      onUploadProgress: progressEvent => {
        if (typeof callback === 'function') {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          callback(percentCompleted);
        }
      },
    });

    if (response && response.success) {
      dispatch(setAttachments(response.messageId, response.attachmentId));
    }
  };
};

export const downloadAttachment = payload => {
  return async dispatch => {
    const response = await downloadAttachmentService(payload);
    if (response) {
      saveAPIFile(response.attachmentData, response.fileName);
    }
  };
};

export const resetAttachments = () => ({
  type: messagingTypes.RESET_ATTACHMENTS,
});

export const deleteAttachment = index => ({
  type: messagingTypes.DELETE_ATTACHMENT,
  index,
});

export const resetComposeId = () => ({
  type: messagingTypes.RESET_COMPOSE_ID,
});

export const resetFilters = () => ({
  type: messagingTypes.RESET_FILTERS,
});

export const setFilters = filters => {
  return async dispatch => {
    dispatch(resetFolders());
    dispatch({ type: messagingTypes.SET_FILTERS, filters });
  };
};

export const resetMessageShown = () => ({
  type: messagingTypes.RESET_MESSAGE_SHOWN,
});

export const getCasesMessagesPending = () => {
  return {
    type: messagingTypes.GET_CASES_MESSAGES_PENDING,
  };
};

export const getCasesMessagesFailure = () => {
  return {
    type: messagingTypes.GET_CASES_MESSAGES_FAILURE,
  };
};

export const getCasesMessagesSuccess = payload => {
  return dispatch => {
    dispatch({
      type: messagingTypes.GET_CASES_MESSAGES_SUCCESS,
      payload,
    });
  };
};

export const getCasesMessages = () => {
  return async (dispatch, getState, setLock, onStart, onComplete) => {
    onStart();

    const caseId = getCaseId(getState());
    const inboxFilters = getFiltersByMailBox(getState(), MESSAGEBOX_TYPES.INBOX);
    const lastInboxDate = getFirstMailDate(getState(), MESSAGEBOX_TYPES.INBOX);

    const params = {
      fromDate: lastInboxDate,
      caseId,
      ...inboxFilters,
    };

    dispatch(getCasesMessagesSuccess(await fetchCasesMessages(params)));
  };
};

export const resumeDraftMode = (emailAddress, caseId) => {
  return async (dispatch, getState) => {
    const accountInfo = await searchParties(emailAddress.toLowerCase(), 1);

    if (accountInfo && !accountInfo.error) {
      dispatch({
        type: messagingTypes.RESUME_DRAFT_MESSAGE,
        accountInfo: accountInfo.emails,
        caseId,
      });
      dispatch(push(MESSAGING_COMPOSE_URL));
    } else if (accountInfo.error && accountInfo.error.message) {
      dispatch(showNotification(accountInfo.error.message, { variant: 'error' }));
    }
  };
};

export const clearResumeDraft = () => ({
  type: messagingTypes.CLEAR_RESUME_DRAFT,
});

export const clearAllMessagesAndCounts = () => ({
  type: messagingTypes.CLEAR_MESSAGES_AND_COUNTS,
});

export const resetFolders = () => ({
  type: messagingTypes.RESET_FOLDERS,
});

export const resetFilterLoader = () => {
  return {
    type: messagingTypes.RESET_IS_FILTER_LOADING,
  };
};

export const resetMessageLoader = () => {
  return {
    type: messagingTypes.RESET_MESSAGE_LOADING,
  };
};

export const setPillFilter = payload => {
  return {
    type: messagingTypes.GET_PILL_FILTER,
    payload,
  };
};
